<template>
  <div class="card border-light">
    <a target="_blank" class="js-link" :href="url"><img class="card-img-top thumbnail" :src="thumb.url"></a>
  </div>
</template>
<script>

export default {
  props: {
    image: {
      type: Object,
      required: true
    }
  },
  computed: {
    url() {
      return this.image.url
    },
    thumb() {
      return this.image.thumb
    }
  }
}
</script>
